import type { SalesDashboardMisFilter } from '@/composables/salesDashboardInjection'

export type SalesTimeRangePreset = 'day' | 'week' | 'month' | 'ytd' | 'ttm' | 'custom'

export type SalesMode = 'created' | 'invoiced'

export interface SalesDashboardCustomRange {
  from: string
  to: string
}

export interface SalesDashboardFilters {
  mis: SalesDashboardMisFilter
  teamUuids: string[]
  teamMemberUuids: string[]
  repKeys: string[]
  orderStatuses: string[]
  productStatuses: string[]
  invoiceStatuses: string[]
  glCodes: string[]
  customerStates: string[]
  accountGroups: string[]
}

export interface SalesDashboardSalesRepOption {
  repKey: string
  salesRepName: string
  salesRepEmail: string | null
  teamUuid: string | null
  filterKeys: string[]
}

export interface SalesFilterOptions {
  orderStatuses: string[]
  productStatuses: string[]
  invoiceStatuses: string[]
  glCodes: string[]
  glNames: string[]
  customerStates: string[]
  customerStatesByCountry: Record<string, string[]>
  accountGroups: string[]
  salesReps: SalesDashboardSalesRepOption[]
}

export const SALES_DASHBOARD_EMPTY_FILTERS: SalesDashboardFilters = {
  mis: 'both',
  teamUuids: [],
  teamMemberUuids: [],
  repKeys: [],
  orderStatuses: [],
  productStatuses: [],
  invoiceStatuses: [],
  glCodes: [],
  customerStates: [],
  accountGroups: [],
}

export const SALES_DASHBOARD_EMPTY_CUSTOM_RANGE: SalesDashboardCustomRange = {
  from: '',
  to: '',
}
